var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dapp-triangle"},[(_vm.direction !== 'both')?_c('div',{staticClass:"triangle",class:{
      up: _vm.direction === 'up',
      down: _vm.direction === 'down',
    }}):_c('div',{staticClass:"both"},[_c('div',{staticClass:"triangle up"}),_c('div',{staticClass:"triangle down"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }